import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import parseInt from 'lodash/parseInt';
import each from 'lodash/each';
import keys from 'lodash/keys';

import {
  FILTER_ENTITY_TYPE_API,
  FILTER_ENTITY_TYPE_API_KEY,
  FILTER_ENTITY_TYPE_APP,
  FILTER_ENTITY_TYPE_ORG,
  FILTER_TYPE_RANK,
  FILTER_TYPE_NAME,
  FILTER_ENTITY_TYPE_GATEWAY,
  FILTER_ENTITY_TYPE_API_PER_ORG,
  FILTER_TYPE_NAME_API_PER_ORG,
  FILTER_TYPE_RANK_API_PER_ORG,
  API_PER_ORG_RANK_FILTER_TYPE_RANK_FOR_ORG,
  API_PER_ORG_RANK_FILTER_TYPE_RANK_FOR_API,
} from '../../../constants/filter';
import {
  TIME_RANGE_HOUR,
  TIME_RANGE_DAY,
  TIME_RANGE_WEEK,
  TIME_RANGE_CUSTOM,
} from '../../../constants/metrics';
import { RespCodeList } from '../../../constants/customReport';

const metricMap = {
  a: FILTER_ENTITY_TYPE_API,
  b: FILTER_ENTITY_TYPE_APP,
  c: FILTER_ENTITY_TYPE_ORG,
  d: FILTER_ENTITY_TYPE_API_PER_ORG,
};

const filterTypeMap = {
  rank: FILTER_TYPE_RANK,
  list: FILTER_TYPE_NAME,
  apiperorgrank: FILTER_TYPE_RANK_API_PER_ORG,
  apiperorglist: FILTER_TYPE_NAME_API_PER_ORG,
};

export const decodeCustomDateFilter = timeRange => {
  const retDate = {};
  if (!isEmpty(timeRange) && !isUndefined(timeRange.type)) {
    if (timeRange.type === 'period') {
      const period = timeRange.period;
      if (period === '24H') {
        retDate.last = 'HOUR_24';
      } else if (period.indexOf('D') > 0 && timeRange.isTextInput) {
        retDate.last = parseInt(period.substr(0, period.length - 1));
      } else if (period === '7D') {
        retDate.last = 'DAY_7';
      }
    } else {
      const dates = timeRange.interval.split('/');
      retDate.customStartDate = moment(dates[0]);
      retDate.customEndDate = moment(dates[1]);
    }
  } else {
    // default value
    retDate.last = 'DAY_7';
  }
  return retDate;
};

export const getFilterTitle = (filterType, intl) => {
  let msgId;
  switch (filterType) {
    case FILTER_ENTITY_TYPE_API:
      msgId = 'label.analyticsDashboard.filter.dialog.title.api';
      break;
    case FILTER_ENTITY_TYPE_API_PER_ORG:
      msgId = 'label.analyticsDashboard.filter.dialog.title.apiperorg';
      break;
    case FILTER_ENTITY_TYPE_API_KEY:
      msgId = 'label.analyticsDashboard.filter.dialog.title.apiKey';
      break;
    case FILTER_ENTITY_TYPE_APP:
      msgId = 'label.analyticsDashboard.filter.dialog.title.app';
      break;
    case FILTER_ENTITY_TYPE_ORG:
      msgId = 'label.analyticsDashboard.filter.dialog.title.org';
      break;
    default: return '';
  }
  return intl.getI18nMessage(msgId);
}

export const decodeMetricsFilter = (metrics) => {
  if (isUndefined(metrics)) {
    return metrics;
  }
  const selectedMetrics = [];
  each(metrics, (metric) => {
    if (isEmpty(metric)) {
      return;
    }
    const filter = {};
    const metricType = Object.keys(metric)[0];
    const metricObj = metric[metricType];
    filter.entityType = metricMap[metricType];
    const filterType = Object.keys(metricObj)[0];
    const filterData = metricObj[filterType];
    filter.filterType = filterTypeMap[filterType];
    if (filter.filterType === FILTER_TYPE_RANK) {
      filter.rank = filterData;
    } else if (filter.filterType === FILTER_TYPE_RANK_API_PER_ORG) {
      filter.rank = filterData;
      filter.rankType = metricObj.rankType;
      const selectedItems = {};
      each(metricObj.list, (item) => {
        selectedItems[item] = true;
      });
      filter.selectedItems = selectedItems;
    } else if ((filter.filterType === FILTER_TYPE_NAME) ||
      (filter.filterType === FILTER_TYPE_NAME_API_PER_ORG)) {
      const selectedItems = {};
      each(filterData, (item) => {
        selectedItems[item] = true;
      });
      filter.selectedItems = selectedItems;
      filter.selectedItemsCount = filterData.length;
    }
    if (!isEmpty(filter)) {
      selectedMetrics.push(filter);
    }
  });
  return selectedMetrics;
};
  
export const decodeDateFilter = (date) => {
  const retDate = {};
  const isLastDate = !isEmpty(date) && !isUndefined(date.last);
  const isCustomDate = !isEmpty(date) && !isUndefined(date.start) && !isUndefined(date.end);
  if (isLastDate) {
    const last = date.last;
    if (last === 'h') {
      retDate.last = 'HOUR_1';
    } else if (last === 'd') {
      retDate.last = 'HOUR_24';
    } else if (last === 'w') {
      retDate.last = 'DAY_7';
    } else if (last.indexOf('d') > 0) {
      retDate.last = parseInt(last.substr(0, date.last.length - 1));
    }
  } else if (isCustomDate) {
    retDate.customEndDate = moment(date.end);
    retDate.customStartDate = moment(date.start);
  } else { // default value
    retDate.last = 'DAY_7';
  }
  return retDate;
};

export const getShorthandDuration = (dateObj) => {
  let shortHandDates;
  if (dateObj.customDays) {
    shortHandDates = `${dateObj.value}d`;
  } else {
    shortHandDates = dateObj.unit.substr(0, 1);
  }
  return shortHandDates;
};

export const getSelectedFilters = (selectedFiltersState) => {
  if (isUndefined(selectedFiltersState)) {
    return {};
  }
  const limit = [];
  const buckets = [];
  const selectedFilters = {};
  let keysArr = [];
  let limitVal = 0;
  each(selectedFiltersState, filterState => {
    if (filterState.entityType === FILTER_ENTITY_TYPE_API) {
      buckets.push('apis');
      if (filterState.filterType === FILTER_TYPE_NAME) {
        keysArr = keys(filterState.selectedItems || {});
        selectedFilters.apiIds = keysArr.join(',');
        limitVal = keysArr.length;
      } else if (filterState.filterType === FILTER_TYPE_RANK) {
        limitVal = filterState.rank;
      }
    } else if (filterState.entityType === FILTER_ENTITY_TYPE_APP) {
      buckets.push('apps');
      if (filterState.filterType === FILTER_TYPE_NAME) {
        keysArr = keys(filterState.selectedItems || {});
        selectedFilters.appIds = keysArr.join(',');
        limitVal = keysArr.length;
      } else if (filterState.filterType === FILTER_TYPE_RANK) {
        limitVal = filterState.rank;
      }
    } else if (filterState.entityType === FILTER_ENTITY_TYPE_ORG) {
      buckets.push('orgs');
      if (filterState.filterType === FILTER_TYPE_NAME) {
        keysArr = keys(filterState.selectedItems || {});
        selectedFilters.orgIds = keysArr.join(',');
        limitVal = keysArr.length;
      } else if (filterState.filterType === FILTER_TYPE_RANK) {
        limitVal = filterState.rank;
      }
    } else if (filterState.entityType === FILTER_ENTITY_TYPE_API_PER_ORG) {
      buckets.push('apiperorgs');
      if (filterState.filterType === FILTER_TYPE_NAME_API_PER_ORG) {
        keysArr = keys(filterState.selectedItems || {});
        const apiIdsArr = [];
        const orgIdsArr = [];
        each(keysArr, key => {
          const ids = key.split('##');
          apiIdsArr.push(ids[0]);
          orgIdsArr.push(ids[1]);
        });
        selectedFilters.orgIds = orgIdsArr.join(',');
        selectedFilters.apiIds = apiIdsArr.join(',');
        limitVal = keysArr.length;
      } else if (filterState.filterType === FILTER_TYPE_RANK_API_PER_ORG) {
        keysArr = keys(filterState.selectedItems || {});
        if (filterState.rankType === API_PER_ORG_RANK_FILTER_TYPE_RANK_FOR_API) {
          selectedFilters.apiIds = keysArr.join(',');
        } else if (filterState.rankType === API_PER_ORG_RANK_FILTER_TYPE_RANK_FOR_ORG) {
          selectedFilters.orgIds = keysArr.join(',');
        }
        limitVal = filterState.rank;
      }
    }
    if (limitVal > 0) {
      limit.push(limitVal);
    }
  });
  selectedFilters.buckets = buckets;
  selectedFilters.limit = limit;
  return selectedFilters;
};

export const getSearchPlaceHolderText = (filterType, intl) => {
  let msgId;
  switch (filterType) {
    case FILTER_ENTITY_TYPE_API:
      msgId = 'label.analyticsDashboard.filter.dialog.search.placeholder.api';
      break;
    case FILTER_ENTITY_TYPE_API_KEY:
      msgId = 'label.analyticsDashboard.filter.dialog.search.placeholder.apiKey';
      break;
    case FILTER_ENTITY_TYPE_APP:
      msgId = 'label.analyticsDashboard.filter.dialog.search.placeholder.app';
      break;
    case FILTER_ENTITY_TYPE_ORG:
      msgId = 'label.analyticsDashboard.filter.dialog.search.placeholder.org';
      break;
    case FILTER_ENTITY_TYPE_GATEWAY:
      msgId = 'label.analyticsDashboard.filter.dialog.search.placeholder.gateway';
      break;
    default: return '';
  }
  return intl.getI18nMessage(msgId);
};

export const getSummaryFromMetricsFilters = (params, entitiesMap, intl) => {
  if (!params) {
    return '';
  }
  const { apiMap, apiKeyMap, appMap, orgMap } = entitiesMap;
  const { buckets, limit } = params;
  const summaryLines = [];
  if (buckets.length === 0) {
    let currentLine = intl.getI18nMessage('label.analytics.print.filters.selected');
    summaryLines.push(currentLine);
    currentLine = intl.getI18nMessage(
      'label.analytics.customReport.dashboard.filter.allData.label',
    );
    summaryLines.push(currentLine);
    return summaryLines;
  }
  summaryLines.push(intl.getI18nMessage('label.analytics.print.filters.selected'));
  const titleMap = {
    api: 'label.analytics.print.filters.apis',
    apiKey: 'label.analytics.print.filters.apiKeys',
    app: 'label.analytics.print.filters.apps',
    org: 'label.analytics.print.filters.orgs',
  };
  const entityMap = {
    api: apiMap,
    apiKey: apiKeyMap,
    app: appMap,
    org: orgMap,
  };
  const bucketEntityTypeMap = {
    apis: 'api',
    apiKeys: 'apiKey',
    apps: 'app',
    orgs: 'org',
  };
  const bucketEntityIdsMap = {
    apis: 'apiIds',
    apiKeys: 'apiKeyIds',
    apps: 'appIds',
    orgs: 'orgIds',
  };
  each(buckets, (bucket, index) => {
    const entityType = bucketEntityTypeMap[bucket];
    let currentLine = intl.getI18nMessage(titleMap[entityType],
      { grouping: '' });
    const idsList = params[bucketEntityIdsMap[bucket]];
    if (idsList) {
      const entitiesArray = [];
      const idsArray = idsList.split(',');
      each(idsArray, id => {
        entitiesArray.push(entityMap[entityType][id]);
      });
      currentLine += entitiesArray.join(', ');
    } else {
      currentLine += intl.getI18nMessage(
        'label.analytics.print.filters.filter.top',
        { rank: limit[index] },
      );
    }
    summaryLines.push(currentLine);
  });

  return summaryLines;
};

export const getSummaryFromMetricsFiltersForCustomReport = (
  filters, entitiesMap, intl,
) => {
  const { apiMap, apiKeyMap, appMap, orgMap, gatewayServerMap } = entitiesMap;
  const summaryLines = [];

  const titleMap = {
    api: 'label.analytics.print.filters.apis',
    apiKey: 'label.analytics.print.filters.apiKeys',
    app: 'label.analytics.print.filters.apps',
    org: 'label.analytics.print.filters.orgs',
    gatewayServer: 'label.analytics.print.filters.proxies',
    respCode: 'label.analytics.print.filters.responseCodes',
    uri: 'label.analytics.print.filters.uri',
  };
  const entityMap = {
    api: apiMap,
    apiKey: apiKeyMap,
    app: appMap,
    org: orgMap,
    gatewayServer: gatewayServerMap,
  };
  if (filters.length) {
    each(filters, (filter) => {
      if (filter.type !== 'default') {
        const entityType = filter.dimension && filter.dimension.replace('Id', '');
        let grouping = '';
        if (filter.type !== 'top') {
          if (filter.isGrouped) {
            grouping = '(Grouped)';
          } else {
            grouping = '(Ungrouped)';
          }
        }
        let currentLine = entityType &&
          intl.getI18nMessage(titleMap[entityType], { grouping });
        const filterType = filter.type;
        if (filterType === 'in') {
          const entitiesArray = [];
          if (filter.dimension === 'respCode') {
            const codesArray = keys(filter.values);
            each(codesArray, code => {
              entitiesArray.push(code);
            });
          } else {
            const idsArray = keys(filter.values);
            each(idsArray, entityId => {
              if (entityType === 'apiKey') {
                const { appName, name } = (entityMap[entityType] &&
                  entityMap[entityType][entityId]) || {};
                if (name && appName) {
                  entitiesArray.push(`${name}(${appName})`);
                } else {
                  entitiesArray.push(name || entityId);
                }
              } else {
                entitiesArray.push(entityMap[entityType][entityId] || entityId);
              }
            });
          }
          currentLine += entitiesArray.join(', ');
        } else if (filterType === 'top') {
          currentLine += intl.getI18nMessage(
            'label.analytics.print.filters.filter.top',
            { rank: filter.limit },
          );
        } else if (filterType === 'regex') {
          const entitiesArray = [];
          const uriArray = filter.values;
          each(uriArray, uri => {
            const name = `${uri.name}(${uri.value})`;
            entitiesArray.push(name);
          });
          currentLine += entitiesArray.join(', ');
        } else if (filterType === 'or') {
          const entitiesArray = [];
          const respCodeArray = filter.fields;
          each(respCodeArray, respCode => {
            const repCodeListItem = RespCodeList[`${respCode.lower}-${respCode.upper}`];
            const name = `${intl.getI18nMessage(
              repCodeListItem.labelKey)} (${intl.getI18nMessage(
              repCodeListItem.rangeKey)})`;
            entitiesArray.push(name);
          });
          currentLine += entitiesArray.join(', ');
        } else if (filterType === 'range') {
          const entitiesArray = [];
          const codesArray = filter.ranges;
          each(codesArray, code => {
            const name = `${code.name} (${code.from}-${code.to})`;
            entitiesArray.push(name);
          });
          currentLine += entitiesArray.join(', ');
        }
        summaryLines.push(currentLine);
      }
    });
  } else {
    summaryLines.push('All Data');
  }

  return summaryLines;
};

export const getSummaryFromDateFilter = (dateObj, intl) => {
  let summaryText = '';
  const dateFormatStr = 'MMM D, YYYY';
  switch (dateObj.timerange) {
    case TIME_RANGE_HOUR:
      summaryText += intl.getI18nMessage('label.analytics.print.filters.date.lasthour');
      break;
    case TIME_RANGE_DAY:
      summaryText += intl.getI18nMessage('label.analytics.print.filters.date.last24hours');
      break;
    case TIME_RANGE_WEEK:
      summaryText += intl.getI18nMessage('label.analytics.print.filters.date.lastweek');
      break;
    case TIME_RANGE_CUSTOM: {
      const startDate = moment(dateObj.startDate).format(dateFormatStr);
      const endDate = moment(dateObj.endDate).format(dateFormatStr);
      summaryText += intl.getI18nMessage(
        'label.analytics.print.filters.date.custom',
        {
          fromDate: startDate,
          toDate: endDate,
        },
      );
    }
      break;
    default: break;
  }
  return summaryText;
};

export const getXValueTick = (xAxisValuesTickMap, key) => {
  if (xAxisValuesTickMap && key && key !== '') {
    return xAxisValuesTickMap[key];
  }
  return null;
};

const encodeEntityType = (entityType, filterItem) => {
  const newFilter = {};
  switch (entityType) {
    case FILTER_ENTITY_TYPE_API:
      newFilter.a = filterItem;
      break;
    case FILTER_ENTITY_TYPE_APP:
      newFilter.b = filterItem;
      break;
    case FILTER_ENTITY_TYPE_ORG:
      newFilter.c = filterItem;
      break;
    case FILTER_ENTITY_TYPE_API_PER_ORG:
      newFilter.d = filterItem;
      break;
    default: return {};
  }
  return newFilter;
};

const getIdsFromFilterSelectedItems = (items) => {
  const ids = [];
  each(items, (item, key) => {
    ids.push(key);
  });
  return ids;
};

export const encodeMetricsFilter = (selectedFiltersState) => {
  const filterState = [];
  each(selectedFiltersState, (item) => {
    const filterItem = {};
    if (item.filterType === FILTER_TYPE_RANK) {
      filterItem.rank = item.rank;
    } else if (item.filterType === FILTER_TYPE_RANK_API_PER_ORG) {
      filterItem.apiperorgrank = item.rank;
      filterItem.rankType = item.rankType;
      filterItem.list = getIdsFromFilterSelectedItems(item.selectedItems);
    } else if (item.filterType === FILTER_TYPE_NAME) {
      filterItem.list = getIdsFromFilterSelectedItems(item.selectedItems);
    } else if (item.filterType === FILTER_TYPE_NAME_API_PER_ORG) {
      filterItem.apiperorglist = getIdsFromFilterSelectedItems(item.selectedItems);
    }
    filterState.push(encodeEntityType(item.entityType, filterItem));
  });
  return filterState;
};